import { Button } from "@/components/ui/button";
import { CheckCircle, ArrowRight, Phone } from "lucide-react";
import SEO from "@/components/SEO";

export default function RefinanceThanksPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 to-white pt-24" data-testid="refinance-thanks-page">
      <SEO
        title="Thank you"
        description="Your refinance plan is on the way."
        path="/refinance-thanks"
        noindex
      />
      <div className="max-w-2xl mx-auto px-6 md:px-12 text-center py-20">
        <div className="w-20 h-20 mx-auto rounded-2xl bg-[#D41F30] flex items-center justify-center mb-8">
          <CheckCircle className="w-10 h-10 text-white" />
        </div>
        <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 mb-5 leading-[1.05] tracking-tight">
          Your refinance plan is on the way.
        </h1>
        <p className="text-lg md:text-xl text-gray-600 mb-10 leading-relaxed">
          A CityWorth refinance expert will reach out within one business day to walk you through your options and lock in the right plan for your goals.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            className="bg-[#D41F30] hover:bg-[#B91C2A] text-white rounded-full px-8 py-7 text-base font-semibold"
            onClick={() => window.location.assign("/")}
          >
            Back to home
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
          <Button
            variant="outline"
            className="border-2 border-gray-300 text-gray-700 hover:bg-gray-50 rounded-full px-8 py-7 text-base font-semibold"
            onClick={() => window.open("tel:+15715551234", "_self")}
          >
            <Phone className="mr-2 w-5 h-5" />
            Call us now
          </Button>
        </div>
      </div>
    </div>
  );
}
